// Libraries
import React from 'react';
import { Link } from 'react-router-dom';
import { getCouverture, ResultIcons } from './utils';
import AsyncImage from '../AsyncImage';

class ResultGridView extends React.Component {
	render() {
		/**
		 * Commun
		 * - titre : text
		 * - id : int
		 * - contenu : html
		 * - couverture
		 * - isPublic
		 * - lang {id, nom,abreg}
		 * - mediaType
		 * - sousTitre
		 * - datePublication
		 * - typeObjet
		 */
		/**
		 * Cantique
		 * - arrangements [{id, nom}]
		 * - origine [{id, nom}]
		 * - remarque
		 * - typeCantiques [{id, nom}]
		 * - langues [{id, nom, abreg}]
		 */
		/**
		 * Recueil
		 * - dateEdition
		 * - isbn
		 * - lienLjc
		 * - prix
		 * - nbrPages *
		 */
		/**
		 * AlbumCd
		 * - dateEdition
		 * - isbn
		 * - lienLjc
		 * - prix
		 * - nbrFichiers *
		 * - dureeTotale *
		 */
		return (
			<div className="col-6 col-lg-6 col-xl-3 text-center mt-5 result">
				<Link
					to={
						'/media/' +
						this.props.result.id +
						'/' +
						this.props.result.titre.split(' ').join('-')
					}
				>
					<div className="img-zoom mx-auto">
						<AsyncImage
							source={getCouverture(this.props.result)}
							placeholderColor="#ececec"
							cssClass="mx-auto result-img async-img-result"
							className="img-fluid pl-3 pr-3"
						/>
					</div>
					<h6 className="mt-2 result-title">{this.props.result.titre}</h6>
					<ResultIcons
						fichierTypePresent={this.props.result.fichierTypePresent}
					/>
				</Link>
			</div>
		);
	}
}

export default ResultGridView;
